/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// @ts-ignore
import type { ConfigurationParameters } from "../configuration";
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from "../configuration";
// @ts-ignore
import type { AxiosError, AxiosResponse } from "axios";
import {
  useQuery,
  UseMutationOptions,
  useMutation,
  UseQueryOptions,
  // @ts-ignore
} from "react-query";
// @ts-ignore
import {
  useAuthorizationToken,
  useAuthQueryKey,
  useApiBasePath,
} from "../../utils";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { GanttDto } from "../models";
// @ts-ignore
import { GanttStripDto } from "../models";
// @ts-ignore
import { ScheduleSlotUpdateDto } from "../models";
// @ts-ignore
import { SlotUpdateResultDto } from "../models";
// @ts-ignore
import { UpdatePeriodDto } from "../models";
/**
 * SlotWebServicesApi - axios parameter creator
 * @export
 */
export const SlotWebServicesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} day
     * @param {string} arr
     * @param {string} dep
     * @param {boolean} [onCurrentDayOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    associateSlotOccurrences: async (
      day: string,
      arr: string,
      dep: string,
      onCurrentDayOnly?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'day' is not null or undefined
      assertParamExists("associateSlotOccurrences", "day", day);
      // verify required parameter 'arr' is not null or undefined
      assertParamExists("associateSlotOccurrences", "arr", arr);
      // verify required parameter 'dep' is not null or undefined
      assertParamExists("associateSlotOccurrences", "dep", dep);
      const localVarPath = `/slot/associate/{day}`.replace(
        `{${"day"}}`,
        encodeURIComponent(String(day))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (arr !== undefined) {
        localVarQueryParameter["arr"] = arr;
      }

      if (dep !== undefined) {
        localVarQueryParameter["dep"] = dep;
      }

      if (onCurrentDayOnly !== undefined) {
        localVarQueryParameter["onCurrentDayOnly"] = onCurrentDayOnly;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {UpdatePeriodDto} updatePeriodDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSlotOccurrences: async (
      id: string,
      updatePeriodDto: UpdatePeriodDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("cancelSlotOccurrences", "id", id);
      // verify required parameter 'updatePeriodDto' is not null or undefined
      assertParamExists(
        "cancelSlotOccurrences",
        "updatePeriodDto",
        updatePeriodDto
      );
      const localVarPath = `/slot/cancel`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updatePeriodDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmSlotOccurrences: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("confirmSlotOccurrences", "id", id);
      const localVarPath = `/slot/confirm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ScheduleSlotUpdateDto} scheduleSlotUpdateDto
     * @param {boolean} [confirm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSlot: async (
      scheduleSlotUpdateDto: ScheduleSlotUpdateDto,
      confirm?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleSlotUpdateDto' is not null or undefined
      assertParamExists(
        "createSlot",
        "scheduleSlotUpdateDto",
        scheduleSlotUpdateDto
      );
      const localVarPath = `/slot/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (confirm !== undefined) {
        localVarQueryParameter["confirm"] = confirm;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        scheduleSlotUpdateDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} day
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDayGanttTurnarounds: async (
      day: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'day' is not null or undefined
      assertParamExists("getDayGanttTurnarounds", "day", day);
      const localVarPath = `/gantt/day/{day}`.replace(
        `{${"day"}}`,
        encodeURIComponent(String(day))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} day
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGanttTurnaroundsToAssociate: async (
      day: string,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'day' is not null or undefined
      assertParamExists("getGanttTurnaroundsToAssociate", "day", day);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("getGanttTurnaroundsToAssociate", "id", id);
      const localVarPath = `/gantt/day/{day}/association`.replace(
        `{${"day"}}`,
        encodeURIComponent(String(day))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [slotId]
     * @param {string} [turnaroundId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSlotStrip: async (
      slotId?: string,
      turnaroundId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/slot`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }

      if (turnaroundId !== undefined) {
        localVarQueryParameter["turnaroundId"] = turnaroundId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    splitSlotOccurrences: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("splitSlotOccurrences", "id", id);
      const localVarPath = `/slot/split`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {ScheduleSlotUpdateDto} scheduleSlotUpdateDto
     * @param {boolean} [confirm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSlotOccurrences: async (
      id: string,
      scheduleSlotUpdateDto: ScheduleSlotUpdateDto,
      confirm?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("updateSlotOccurrences", "id", id);
      // verify required parameter 'scheduleSlotUpdateDto' is not null or undefined
      assertParamExists(
        "updateSlotOccurrences",
        "scheduleSlotUpdateDto",
        scheduleSlotUpdateDto
      );
      const localVarPath = `/slot/update`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      if (confirm !== undefined) {
        localVarQueryParameter["confirm"] = confirm;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        scheduleSlotUpdateDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SlotWebServicesApi - functional programming interface
 * @export
 */
export const SlotWebServicesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SlotWebServicesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} day
     * @param {string} arr
     * @param {string} dep
     * @param {boolean} [onCurrentDayOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async associateSlotOccurrences(
      day: string,
      arr: string,
      dep: string,
      onCurrentDayOnly?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SlotUpdateResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.associateSlotOccurrences(
          day,
          arr,
          dep,
          onCurrentDayOnly,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {UpdatePeriodDto} updatePeriodDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelSlotOccurrences(
      id: string,
      updatePeriodDto: UpdatePeriodDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SlotUpdateResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cancelSlotOccurrences(
          id,
          updatePeriodDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmSlotOccurrences(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SlotUpdateResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.confirmSlotOccurrences(id, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {ScheduleSlotUpdateDto} scheduleSlotUpdateDto
     * @param {boolean} [confirm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createSlot(
      scheduleSlotUpdateDto: ScheduleSlotUpdateDto,
      confirm?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SlotUpdateResultDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createSlot(
        scheduleSlotUpdateDto,
        confirm,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} day
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDayGanttTurnarounds(
      day: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GanttDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDayGanttTurnarounds(day, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} day
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGanttTurnaroundsToAssociate(
      day: string,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GanttDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getGanttTurnaroundsToAssociate(
          day,
          id,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} [slotId]
     * @param {string} [turnaroundId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSlotStrip(
      slotId?: string,
      turnaroundId?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GanttStripDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSlotStrip(
        slotId,
        turnaroundId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async splitSlotOccurrences(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SlotUpdateResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.splitSlotOccurrences(id, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {ScheduleSlotUpdateDto} scheduleSlotUpdateDto
     * @param {boolean} [confirm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSlotOccurrences(
      id: string,
      scheduleSlotUpdateDto: ScheduleSlotUpdateDto,
      confirm?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SlotUpdateResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateSlotOccurrences(
          id,
          scheduleSlotUpdateDto,
          confirm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
  };
};

/**
 * SlotWebServicesApi - factory interface
 * @export
 */
export const SlotWebServicesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SlotWebServicesApiFp(configuration);
  return {
    /**
     *
     * @param {SlotWebServicesApiAssociateSlotOccurrencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    associateSlotOccurrences(
      requestParameters: SlotWebServicesApiAssociateSlotOccurrencesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<SlotUpdateResultDto> {
      return localVarFp
        .associateSlotOccurrences(
          requestParameters.day,
          requestParameters.arr,
          requestParameters.dep,
          requestParameters.onCurrentDayOnly,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SlotWebServicesApiCancelSlotOccurrencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSlotOccurrences(
      requestParameters: SlotWebServicesApiCancelSlotOccurrencesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<SlotUpdateResultDto> {
      return localVarFp
        .cancelSlotOccurrences(
          requestParameters.id,
          requestParameters.updatePeriodDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SlotWebServicesApiConfirmSlotOccurrencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmSlotOccurrences(
      requestParameters: SlotWebServicesApiConfirmSlotOccurrencesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<SlotUpdateResultDto> {
      return localVarFp
        .confirmSlotOccurrences(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SlotWebServicesApiCreateSlotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSlot(
      requestParameters: SlotWebServicesApiCreateSlotRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<SlotUpdateResultDto> {
      return localVarFp
        .createSlot(
          requestParameters.scheduleSlotUpdateDto,
          requestParameters.confirm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SlotWebServicesApiGetDayGanttTurnaroundsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDayGanttTurnarounds(
      requestParameters: SlotWebServicesApiGetDayGanttTurnaroundsRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<GanttDto> {
      return localVarFp
        .getDayGanttTurnarounds(requestParameters.day, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGanttTurnaroundsToAssociate(
      requestParameters: SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<GanttDto> {
      return localVarFp
        .getGanttTurnaroundsToAssociate(
          requestParameters.day,
          requestParameters.id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SlotWebServicesApiGetSlotStripRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSlotStrip(
      requestParameters: SlotWebServicesApiGetSlotStripRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<GanttStripDto> {
      return localVarFp
        .getSlotStrip(
          requestParameters.slotId,
          requestParameters.turnaroundId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SlotWebServicesApiSplitSlotOccurrencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    splitSlotOccurrences(
      requestParameters: SlotWebServicesApiSplitSlotOccurrencesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<SlotUpdateResultDto> {
      return localVarFp
        .splitSlotOccurrences(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SlotWebServicesApiUpdateSlotOccurrencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSlotOccurrences(
      requestParameters: SlotWebServicesApiUpdateSlotOccurrencesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<SlotUpdateResultDto> {
      return localVarFp
        .updateSlotOccurrences(
          requestParameters.id,
          requestParameters.scheduleSlotUpdateDto,
          requestParameters.confirm,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for associateSlotOccurrences operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiAssociateSlotOccurrencesRequest
 */
export interface SlotWebServicesApiAssociateSlotOccurrencesRequest {
  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiAssociateSlotOccurrences
   */
  readonly day: string;

  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiAssociateSlotOccurrences
   */
  readonly arr: string;

  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiAssociateSlotOccurrences
   */
  readonly dep: string;

  /**
   *
   * @type {boolean}
   * @memberof SlotWebServicesApiAssociateSlotOccurrences
   */
  readonly onCurrentDayOnly?: boolean;
}

/**
 * Request parameters for cancelSlotOccurrences operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiCancelSlotOccurrencesRequest
 */
export interface SlotWebServicesApiCancelSlotOccurrencesRequest {
  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiCancelSlotOccurrences
   */
  readonly id: string;

  /**
   *
   * @type {UpdatePeriodDto}
   * @memberof SlotWebServicesApiCancelSlotOccurrences
   */
  readonly updatePeriodDto: UpdatePeriodDto;
}

/**
 * Request parameters for confirmSlotOccurrences operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiConfirmSlotOccurrencesRequest
 */
export interface SlotWebServicesApiConfirmSlotOccurrencesRequest {
  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiConfirmSlotOccurrences
   */
  readonly id: string;
}

/**
 * Request parameters for createSlot operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiCreateSlotRequest
 */
export interface SlotWebServicesApiCreateSlotRequest {
  /**
   *
   * @type {ScheduleSlotUpdateDto}
   * @memberof SlotWebServicesApiCreateSlot
   */
  readonly scheduleSlotUpdateDto: ScheduleSlotUpdateDto;

  /**
   *
   * @type {boolean}
   * @memberof SlotWebServicesApiCreateSlot
   */
  readonly confirm?: boolean;
}

/**
 * Request parameters for getDayGanttTurnarounds operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiGetDayGanttTurnaroundsRequest
 */
export interface SlotWebServicesApiGetDayGanttTurnaroundsRequest {
  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiGetDayGanttTurnarounds
   */
  readonly day: string;
}

/**
 * Request parameters for getGanttTurnaroundsToAssociate operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest
 */
export interface SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest {
  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiGetGanttTurnaroundsToAssociate
   */
  readonly day: string;

  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiGetGanttTurnaroundsToAssociate
   */
  readonly id: string;
}

/**
 * Request parameters for getSlotStrip operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiGetSlotStripRequest
 */
export interface SlotWebServicesApiGetSlotStripRequest {
  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiGetSlotStrip
   */
  readonly slotId?: string;

  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiGetSlotStrip
   */
  readonly turnaroundId?: string;
}

/**
 * Request parameters for splitSlotOccurrences operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiSplitSlotOccurrencesRequest
 */
export interface SlotWebServicesApiSplitSlotOccurrencesRequest {
  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiSplitSlotOccurrences
   */
  readonly id: string;
}

/**
 * Request parameters for updateSlotOccurrences operation in SlotWebServicesApi.
 * @export
 * @interface SlotWebServicesApiUpdateSlotOccurrencesRequest
 */
export interface SlotWebServicesApiUpdateSlotOccurrencesRequest {
  /**
   *
   * @type {string}
   * @memberof SlotWebServicesApiUpdateSlotOccurrences
   */
  readonly id: string;

  /**
   *
   * @type {ScheduleSlotUpdateDto}
   * @memberof SlotWebServicesApiUpdateSlotOccurrences
   */
  readonly scheduleSlotUpdateDto: ScheduleSlotUpdateDto;

  /**
   *
   * @type {boolean}
   * @memberof SlotWebServicesApiUpdateSlotOccurrences
   */
  readonly confirm?: boolean;
}

/**
 * SlotWebServicesApi - object-oriented interface
 * @export
 * @class SlotWebServicesApi
 * @extends {BaseAPI}
 */
export class SlotWebServicesApi extends BaseAPI {
  /**
   *
   * @param {SlotWebServicesApiAssociateSlotOccurrencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public associateSlotOccurrences(
    requestParameters: SlotWebServicesApiAssociateSlotOccurrencesRequest,
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .associateSlotOccurrences(
        requestParameters.day,
        requestParameters.arr,
        requestParameters.dep,
        requestParameters.onCurrentDayOnly,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SlotWebServicesApiCancelSlotOccurrencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public cancelSlotOccurrences(
    requestParameters: SlotWebServicesApiCancelSlotOccurrencesRequest,
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .cancelSlotOccurrences(
        requestParameters.id,
        requestParameters.updatePeriodDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SlotWebServicesApiConfirmSlotOccurrencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public confirmSlotOccurrences(
    requestParameters: SlotWebServicesApiConfirmSlotOccurrencesRequest,
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .confirmSlotOccurrences(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SlotWebServicesApiCreateSlotRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public createSlot(
    requestParameters: SlotWebServicesApiCreateSlotRequest,
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .createSlot(
        requestParameters.scheduleSlotUpdateDto,
        requestParameters.confirm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SlotWebServicesApiGetDayGanttTurnaroundsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public getDayGanttTurnarounds(
    requestParameters: SlotWebServicesApiGetDayGanttTurnaroundsRequest,
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .getDayGanttTurnarounds(requestParameters.day, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public getGanttTurnaroundsToAssociate(
    requestParameters: SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest,
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .getGanttTurnaroundsToAssociate(
        requestParameters.day,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SlotWebServicesApiGetSlotStripRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public getSlotStrip(
    requestParameters: SlotWebServicesApiGetSlotStripRequest = {},
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .getSlotStrip(
        requestParameters.slotId,
        requestParameters.turnaroundId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SlotWebServicesApiSplitSlotOccurrencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public splitSlotOccurrences(
    requestParameters: SlotWebServicesApiSplitSlotOccurrencesRequest,
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .splitSlotOccurrences(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SlotWebServicesApiUpdateSlotOccurrencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SlotWebServicesApi
   */
  public updateSlotOccurrences(
    requestParameters: SlotWebServicesApiUpdateSlotOccurrencesRequest,
    options?: AxiosRequestConfig
  ) {
    return SlotWebServicesApiFp(this.configuration)
      .updateSlotOccurrences(
        requestParameters.id,
        requestParameters.scheduleSlotUpdateDto,
        requestParameters.confirm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

// custom hook generation here
export type PostAssociateSlotOccurrencesResponse =
  AxiosResponse<SlotUpdateResultDto>;
export const KeyPostAssociateSlotOccurrences = "PostAssociateSlotOccurrences";
export const useMutationPostAssociateSlotOccurrences = (
  options?: UseMutationOptions<
    PostAssociateSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiAssociateSlotOccurrencesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostAssociateSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiAssociateSlotOccurrencesRequest
  >(
    (args: SlotWebServicesApiAssociateSlotOccurrencesRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).associateSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostAssociateSlotOccurrences = (
  args: SlotWebServicesApiAssociateSlotOccurrencesRequest,
  options?: UseQueryOptions<PostAssociateSlotOccurrencesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostAssociateSlotOccurrencesResponse, AxiosError>(
    [
      KeyPostAssociateSlotOccurrences,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).associateSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostCancelSlotOccurrencesResponse =
  AxiosResponse<SlotUpdateResultDto>;
export const KeyPostCancelSlotOccurrences = "PostCancelSlotOccurrences";
export const useMutationPostCancelSlotOccurrences = (
  options?: UseMutationOptions<
    PostCancelSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiCancelSlotOccurrencesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostCancelSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiCancelSlotOccurrencesRequest
  >(
    (args: SlotWebServicesApiCancelSlotOccurrencesRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).cancelSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostCancelSlotOccurrences = (
  args: SlotWebServicesApiCancelSlotOccurrencesRequest,
  options?: UseQueryOptions<PostCancelSlotOccurrencesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostCancelSlotOccurrencesResponse, AxiosError>(
    [
      KeyPostCancelSlotOccurrences,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).cancelSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostConfirmSlotOccurrencesResponse =
  AxiosResponse<SlotUpdateResultDto>;
export const KeyPostConfirmSlotOccurrences = "PostConfirmSlotOccurrences";
export const useMutationPostConfirmSlotOccurrences = (
  options?: UseMutationOptions<
    PostConfirmSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiConfirmSlotOccurrencesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostConfirmSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiConfirmSlotOccurrencesRequest
  >(
    (args: SlotWebServicesApiConfirmSlotOccurrencesRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).confirmSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostConfirmSlotOccurrences = (
  args: SlotWebServicesApiConfirmSlotOccurrencesRequest,
  options?: UseQueryOptions<PostConfirmSlotOccurrencesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostConfirmSlotOccurrencesResponse, AxiosError>(
    [
      KeyPostConfirmSlotOccurrences,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).confirmSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostCreateSlotResponse = AxiosResponse<SlotUpdateResultDto>;
export const KeyPostCreateSlot = "PostCreateSlot";
export const useMutationPostCreateSlot = (
  options?: UseMutationOptions<
    PostCreateSlotResponse,
    AxiosError,
    SlotWebServicesApiCreateSlotRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostCreateSlotResponse,
    AxiosError,
    SlotWebServicesApiCreateSlotRequest
  >(
    (args: SlotWebServicesApiCreateSlotRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).createSlot(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostCreateSlot = (
  args: SlotWebServicesApiCreateSlotRequest,
  options?: UseQueryOptions<PostCreateSlotResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostCreateSlotResponse, AxiosError>(
    [KeyPostCreateSlot, args, options && options.queryKey, authQueryKey],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).createSlot(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type GetGetDayGanttTurnaroundsResponse = AxiosResponse<GanttDto>;
export const KeyGetGetDayGanttTurnarounds = "GetGetDayGanttTurnarounds";
export const useMutationGetGetDayGanttTurnarounds = (
  options?: UseMutationOptions<
    GetGetDayGanttTurnaroundsResponse,
    AxiosError,
    SlotWebServicesApiGetDayGanttTurnaroundsRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    GetGetDayGanttTurnaroundsResponse,
    AxiosError,
    SlotWebServicesApiGetDayGanttTurnaroundsRequest
  >(
    (args: SlotWebServicesApiGetDayGanttTurnaroundsRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).getDayGanttTurnarounds(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetGetDayGanttTurnarounds = (
  args: SlotWebServicesApiGetDayGanttTurnaroundsRequest,
  options?: UseQueryOptions<GetGetDayGanttTurnaroundsResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetGetDayGanttTurnaroundsResponse, AxiosError>(
    [
      KeyGetGetDayGanttTurnarounds,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).getDayGanttTurnarounds(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type GetGetGanttTurnaroundsToAssociateResponse = AxiosResponse<GanttDto>;
export const KeyGetGetGanttTurnaroundsToAssociate =
  "GetGetGanttTurnaroundsToAssociate";
export const useMutationGetGetGanttTurnaroundsToAssociate = (
  options?: UseMutationOptions<
    GetGetGanttTurnaroundsToAssociateResponse,
    AxiosError,
    SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    GetGetGanttTurnaroundsToAssociateResponse,
    AxiosError,
    SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest
  >(
    (args: SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).getGanttTurnaroundsToAssociate(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetGetGanttTurnaroundsToAssociate = (
  args: SlotWebServicesApiGetGanttTurnaroundsToAssociateRequest,
  options?: UseQueryOptions<
    GetGetGanttTurnaroundsToAssociateResponse,
    AxiosError
  >,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetGetGanttTurnaroundsToAssociateResponse, AxiosError>(
    [
      KeyGetGetGanttTurnaroundsToAssociate,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).getGanttTurnaroundsToAssociate(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type GetGetSlotStripResponse = AxiosResponse<GanttStripDto>;
export const KeyGetGetSlotStrip = "GetGetSlotStrip";
export const useMutationGetGetSlotStrip = (
  options?: UseMutationOptions<
    GetGetSlotStripResponse,
    AxiosError,
    SlotWebServicesApiGetSlotStripRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    GetGetSlotStripResponse,
    AxiosError,
    SlotWebServicesApiGetSlotStripRequest
  >(
    (args: SlotWebServicesApiGetSlotStripRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).getSlotStrip(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetGetSlotStrip = (
  args: SlotWebServicesApiGetSlotStripRequest,
  options?: UseQueryOptions<GetGetSlotStripResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetGetSlotStripResponse, AxiosError>(
    [KeyGetGetSlotStrip, args, options && options.queryKey, authQueryKey],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).getSlotStrip(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostSplitSlotOccurrencesResponse =
  AxiosResponse<SlotUpdateResultDto>;
export const KeyPostSplitSlotOccurrences = "PostSplitSlotOccurrences";
export const useMutationPostSplitSlotOccurrences = (
  options?: UseMutationOptions<
    PostSplitSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiSplitSlotOccurrencesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostSplitSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiSplitSlotOccurrencesRequest
  >(
    (args: SlotWebServicesApiSplitSlotOccurrencesRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).splitSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostSplitSlotOccurrences = (
  args: SlotWebServicesApiSplitSlotOccurrencesRequest,
  options?: UseQueryOptions<PostSplitSlotOccurrencesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostSplitSlotOccurrencesResponse, AxiosError>(
    [
      KeyPostSplitSlotOccurrences,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).splitSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostUpdateSlotOccurrencesResponse =
  AxiosResponse<SlotUpdateResultDto>;
export const KeyPostUpdateSlotOccurrences = "PostUpdateSlotOccurrences";
export const useMutationPostUpdateSlotOccurrences = (
  options?: UseMutationOptions<
    PostUpdateSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiUpdateSlotOccurrencesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostUpdateSlotOccurrencesResponse,
    AxiosError,
    SlotWebServicesApiUpdateSlotOccurrencesRequest
  >(
    (args: SlotWebServicesApiUpdateSlotOccurrencesRequest) =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).updateSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostUpdateSlotOccurrences = (
  args: SlotWebServicesApiUpdateSlotOccurrencesRequest,
  options?: UseQueryOptions<PostUpdateSlotOccurrencesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostUpdateSlotOccurrencesResponse, AxiosError>(
    [
      KeyPostUpdateSlotOccurrences,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new SlotWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).updateSlotOccurrences(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
